require('./bootstrap');

import * as Vue from 'vue'
import * as VueRouter from 'vue-router'
import App from './App.vue'
import * as VueAxios from 'vue-axios'
import axios from 'axios'
import { routes } from './routes'
import VueGTag from 'vue-gtag'

import * as All from 'quasar'
import { Cookies, Dialog, EventBus, Loading, Notify, Quasar, ClosePopup } from 'quasar'
import quasarIconSet from 'quasar/icon-set/svg-fontawesome-v6'
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css'
import 'quasar/src/css/index.sass'
import 'quasar/dist/quasar.addon.prod.css'
import store from './store/index'

// Sentry
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

window.Vue = require('vue');

const router = VueRouter.createRouter({
    history: VueRouter.createWebHistory(),
    base: __dirname,
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (to.hash.length && document.querySelector(to.hash)) {
            return {
                el: to.hash,
                behavior: 'smooth'
            }
        }

        if (savedPosition) {
            return savedPosition
        }
    }
});

const vueAxios = VueAxios.default;
const axiosInstance = axios.create({
    responseType: 'json',
    baseURL: process.env.MIX_APP_URL + '/api/',
    withCredentials: true,
});

axiosInstance.interceptors.response.use(response => {
    return response;
}, async error => {
    if (error.response.status === 401) {
        Cookies.remove('_auth_token', {path: '/'});
        store.commit('logout');
        delete axiosInstance.defaults.headers.common['Authorization'];
        await router.push({name: 'home'});
    }
    return error;
});

window.axios = axiosInstance;

const app = Vue.createApp(App);

app.config
app.use(router)
app.use(vueAxios, axiosInstance)
app.use(Quasar, {
    iconSet: quasarIconSet,
    cssAddon: true,
    directives: [ClosePopup],
    plugins: [Cookies, Dialog, EventBus, Loading, Notify],
    components: All,
    config: {
        brand: {
            primary: '#1e6c8e',     // muted blue
            secondary: '#27aae1',   //light blue
            accent: '#ff0000',      //red

            dark: '#252424',        //dark grey
            'dark-page': '#121212',//almost black

            positive: '#54ba6c', //green
            negative: '#c94756', //light red
            info: '#82c4d1',     //very light blue
            warning: '#edaf02',   //muted orange
            important: '#ff5722' //orange
        },
        screen: {
            bodyClasses: true,
        }
    }
});
if (process.env.MIX_GOOGLE_ANALYTICS_ID) {
    app.use(VueGTag, {
        appName: 'Memo Link',
        bootstrap: false,
        pageTrackerScreenviewEnabled: true,
        config: {
            id: process.env.MIX_GOOGLE_ANALYTICS_ID,
        }
    }, router);
}
app.use(store);
Sentry.init({
    app,
    dsn: process.env.MIX_SENTRY_DSN,
    integrations: [
        // TODO: update deprecation
        new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ["memo.link", /^\//],
        }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.0,
});

app.provide('appUrl', process.env.MIX_APP_URL + '/');
app.provide('appDomain', process.env.MIX_APP_DOMAIN);
app.provide('eventBus', new EventBus());
app.provide('axios', app.config.globalProperties.axios);
app.provide('milestoneProgress', process.env.MIX_MILESTONE_PROGRESS);

const daysBeforeExtend = process.env.MIX_MEMO_LINK_ALLOW_EXTEND_X_DAYS_BEFORE !== ''
    ? process.env.MIX_MEMO_LINK_ALLOW_EXTEND_X_DAYS_BEFORE
    : 21;

app.provide('allowExtendXDaysBefore', parseInt(daysBeforeExtend));
app.mount('#app');

